import { IChatItem } from './chat';
import { ReasoningStep } from './reasoning';

/**
 * Cita ya numerada y deduplicada, lista para pintarse en el bloque de fuentes.
 */
export interface DisplayCitation {
  index: number;
  label: string;
  url?: string;
  fileId?: string;
  quote?: string;
}

/**
 * Mensaje tal como lo necesita la vista. Extiende el contrato del servicio con
 * el estado que solo vive en el cliente (streaming, razonamiento, feedback).
 */
export interface ChatMessage extends IChatItem {
  /** Texto ya listo para el markdown, con las citas reemplazadas por su número */
  display?: string;
  /** Citas numeradas que se muestran bajo la burbuja */
  citations?: DisplayCitation[];
  /** El mensaje todavía está recibiendo tokens del agente */
  isStreaming?: boolean;
  /** Pasos de razonamiento reportados por el agente mientras responde */
  reasoning?: ReasoningStep[];
  /** El usuario expandió el detalle del razonamiento */
  reasoningOpen?: boolean;
  /** Blueprints de gráficos que emite el agente, en json */
  charts?: string[];
  /** Pregunta que originó esta respuesta, se envía junto al feedback */
  question?: string;
  /** Reacción elegida por el usuario */
  feedback?: 'like' | 'dislike';
  /** El feedback ya se registró en el backend */
  feedbackSent?: boolean;
  /** Caja de comentario abierta tras un dislike */
  feedbackOpen?: boolean;
  /** Comentario que el usuario escribe junto al dislike */
  feedbackText?: string;
  /** Respuesta ya enviada a una solicitud de aprobación de MCP */
  approvalResolved?: boolean;
}
